import humps from 'humps';

import {
  receiveBusinessList,
  showRequestFailureAlert,
} from 'actions/ApiAction';

import { MogamboRequest, authenticate, captureException } from './index';
import { mogamboRequestV2 } from './utils';

import { BASE_URL } from '../const';

export const getAllBusinessList = (callback) => {
  const url = `${BASE_URL}business/`;
  const request = MogamboRequest(url, 'GET');

  fetch(request)
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        response.json().then((json) => {
          authenticate(json);
          if (json.success) {
            receiveBusinessList(
              humps.camelizeKeys(json.body),
              humps.camelizeKeys(json.meta)
            );
            if (callback) callback();
          } else {
            showRequestFailureAlert(
              json.error || 'There was an error in fetching the businesses.'
            );
          }
        });
      }
      console.log('API request failed!');
    })
    .catch(captureException);
};

export const getBusinessPartnerList = () => {
  const url = `${BASE_URL}partner/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const getAllPlatforms = () => {
  const url = `${BASE_URL}all_platforms/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};
